class PrintController {
    /*@ngInject*/
    constructor($translate, DateUtil) {
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.model = {
            reportDataObj: null,
            branchTimeZone: null
        };
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.reportDataObj = window.opener.w.printData;
            this.model.branchTimeZone = window.opener.w.printData.branchTimeZone;
            this.print();
        }
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 1500)
    }
    formattedDate(date, fromVault = false) {
        const validatationTime = moment.utc(date).format('HH:mm:ss');
        if (validatationTime === '00:00:00') {
            return fromVault ? moment.utc(date).format('YYYY-MM-DD') : moment.utc(date).format('YYYY-MM-DD | hh:mm a');
        } else {
            return fromVault ? this.DateUtil.convertDateTime(
                date,
                this.model.branchTimeZone,
                'YYYY-MM-DD'
            ) : this.DateUtil.convertDateTime(
                date,
                this.model.branchTimeZone,
                'YYYY-MM-DD | hh:mm a'
            );
        }
    }

}
export default PrintController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/print/customer_report.controller.js